import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EappBeneficiaryGateway } from '../gateways/EAppEnrollment-gateway'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { EappUpdateStatus } from '../models/beneficiary-status-model'
import { UserProfile } from '../../user-management/models/user-profile'
@Component({
    selector: 'EAppEnrollmentButton',
    templateUrl: 'e-app-verify-correction.component.html',
     styleUrls: ['./EApp-beneficiary.component.scss']
})

export class EAppEnrollmentButtonComponent implements OnInit {
    private uniqueLink: string
    id: string
    correction: boolean = false
    hasError: boolean
    ErrorMessages: any[]
    txtCorrection: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    eappUpdateStatusModel: EappUpdateStatus = {} as EappUpdateStatus
    agentId: number
    userProfileModel: UserProfile
    showUpdatesSettingsMessage = 'Success'
    icid: string
    constructor(private router: Router, private route: ActivatedRoute, private _enrollmentGateway: EappBeneficiaryGateway) {
        this.userProfileModel = {} as UserProfile
    }
    ngOnInit() {
        this.getParams();
        if (this.id === "1") {
            this.correction = true
        }
        else {
            this.correction = false
        }
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.agentId = Number(this.enrollmentViewModel.AGENTID)
    }
    getParams() {
        this.route.params.forEach((params: Params) => {
            this.id = this.route.snapshot.params['id']
            this.uniqueLink = this.route.snapshot.params['guid']
            this.icid = this.route.snapshot.params['icid']
        })
    }

    continueClick() {
        if (!this.correction) {
            this.eappUpdateStatusModel.ApplicationStatus = "Rejected"
            this.eappUpdateStatusModel.UniqueLink = this.enrollmentViewModel.UNIQUELINK
            this.eappUpdateStatusModel.LinkExpired = true
            this.eappUpdateStatusModel.LinkViewed = true
            this.eappUpdateStatusModel.Reason = ""
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel)
                .subscribe((model: any) => {
                    let response = model
                    if (response === undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            window.scrollTo(0, 0)
                        }
                        else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            window.scrollTo(0, 0)
                        }
                    }
                    else {
                        //this._enrollmentGateway.findUserProfileByProfileID(this.agentId).subscribe(
                        //    (model: UserProfile) => {
                        //        this.userProfileModel = model
                        //        if (this.userProfileModel.Email !== null && this.userProfileModel.Email !== undefined) {
                        //            this._enrollmentGateway.SendAgentEmail(this.userProfileModel.Email, null, this.userProfileModel.FirstName + '' + this.userProfileModel.LastName, this.enrollmentViewModel.APPFN).subscribe(() => this.showUpdatesSettingsMessage = 'Success')
                        //        }
                        //    })
                        //this._enrollmentGateway
                        //    .notifyeAppAgent(this.agentId, this.enrollmentViewModel.APPFN, this.enrollmentViewModel.APPLN, this.eappUpdateStatusModel.ApplicationStatus)
                        //    .subscribe(() => {
                        //        this.showUpdatesSettingsMessage = 'Success'
                        //    })

                        this.router.navigate(['/messages/' + "2" +"/" + this.icid])
                    }
                })
        }
        else {
            this.eappUpdateStatusModel.ApplicationStatus = "Correction"
            this.eappUpdateStatusModel.UniqueLink = this.enrollmentViewModel.UNIQUELINK
            this.eappUpdateStatusModel.LinkExpired = true
            this.eappUpdateStatusModel.LinkViewed = true
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel)
                .subscribe((model: any) => {
                    let response = model
                    if (response === undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            window.scrollTo(0, 0)
                        }
                        else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            window.scrollTo(0, 0)
                        }
                    }
                    else {
                        //this._enrollmentGateway.findUserProfileByProfileID(this.agentId).subscribe(
                        //    (model: UserProfile) => {
                        //        this.userProfileModel = model
                        //        if (this.userProfileModel.Email !== null && this.userProfileModel.Email !== undefined) {
                        //            this._enrollmentGateway.SendAgentEmail(this.userProfileModel.Email, this.eappUpdateStatusModel.Reason, this.userProfileModel.FirstName + '' + this.userProfileModel.LastName, this.enrollmentViewModel.APPFN).subscribe(() => this.showUpdatesSettingsMessage = 'Success')
                        //        }
                        //    })
                        //this._enrollmentGateway
                        //    .notifyeAppAgent(this.agentId, this.enrollmentViewModel.APPFN, this.enrollmentViewModel.APPLN, this.eappUpdateStatusModel.ApplicationStatus)
                        //    .subscribe(() => {
                        //        this.showUpdatesSettingsMessage = 'Success'
                        //    })

                        this.router.navigate(['/messages/' + "4" + "/" + this.icid])
                    }
                })
        }
    }

    btnBack() {
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.router.navigate(['/Step2/' + this.uniqueLink])
    }

}